import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalBody, ModalHeader, Label, Input } from 'reactstrap';
import { useSelector , useDispatch } from 'react-redux';
// import FileManagerWithSidebar from './File_manager/FileManagerWithSidebar';
import { Get_Share_Point_Files, Save_Share_Point_Creds} from '../../../slices/thunks';

const Import_Sharepoint = ({ modal_standard ,  setmodal_standard }) => {
    // modal


    function tog_standard() {
        setmodal_standard(!modal_standard);
    }
// modal end
  const { Bot_ID , Sharepoint_Details } = useSelector((state) => state.BotDetails.Bot_Details);
  const { loading } = useSelector((state) => state.SharePoint);
  const [selected_files, setselected_files] = useState([])


  const {Site_Url,Site_Name,Client_Id,Client_Secret,Tenant_Id} = Sharepoint_Details ?  Sharepoint_Details : {}

  const dispatch = useDispatch()

  const [share_point_creds, setshare_point_creds] = useState({
    bot_id: Bot_ID,
    client_id: '',
    client_secret: '',
    site_name: '',
    site_url: '',
    tenant_id: ''
  });

  useEffect(() => {
      setshare_point_creds({
      bot_id: Bot_ID,
      client_id: Client_Id,
      client_secret: Client_Secret,
      site_name: Site_Name,
      site_url: Site_Url,
      tenant_id: Tenant_Id
  })
  }, [Site_Url,Site_Name,Client_Id,Client_Secret,Tenant_Id])


  useEffect(() => {
   

      dispatch(Get_Share_Point_Files({bot_id:Bot_ID}))

  }, [])
  

  // useEffect(() => {
  //  setshare_point_creds(sharepoint_creds)
  // }, [sharepoint_creds])
  
  

  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);

  const on_change_client_id = (e) => {
    const client_id = e.target.value;
    setshare_point_creds((prev) => ({
      ...prev,
      client_id
    }));
  };

  const on_change_client_secret = (e) => {
    const client_secret = e.target.value;
    setshare_point_creds((prev) => ({
      ...prev,
      client_secret
    }));
  };

  const on_change_site_name = (e) => {
    const site_name = e.target.value;
    setshare_point_creds((prev) => ({
      ...prev,
      site_name
    }));
  };

  const on_change_site_url = (e) => {
    const site_url = e.target.value;
    setshare_point_creds((prev) => ({
      ...prev,
      site_url
    }));
  };

  const on_change_tenant_id = (e) => {
    const tenant_id = e.target.value;
    setshare_point_creds((prev) => ({
      ...prev,
      tenant_id
    }));
  };

  // Validate the form
  const validateForm = () => {
    let formErrors = {};
    if (!share_point_creds.site_url) formErrors.site_url = 'Site URL is required';
    if (!share_point_creds.site_name) formErrors.site_name = 'Site Name is required';
    if (!share_point_creds.client_id) formErrors.client_id = 'Client ID is required';
    if (!share_point_creds.client_secret) formErrors.client_secret = 'Client Secret is required';
    if (!share_point_creds.tenant_id) formErrors.tenant_id = 'Tenant ID is required';

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };
    useEffect(() => {
      setIsFormValid(validateForm()); // Re-run validation only when form state changes
    }, [share_point_creds]); // Run this effect when share_point_creds state changes
  
  
  
  
    const handleFetchFiles = () => {
      if (isFormValid) {
        let temp = JSON.parse(JSON.stringify(share_point_creds))
        temp.bot_id = Bot_ID
        
        dispatch(Save_Share_Point_Creds(temp))
      }
    };

  return (
    <>
   <Button onClick={() => tog_standard()}>Import Share Point</Button>

                    {/* Default Modal */}
            <Modal id="myModal"
                isOpen={modal_standard}
                toggle={() => {
                    tog_standard();
                }}
            >
                <ModalHeader className="modal-title"
                style={{borderBottom:'1px solid #ddd'}}
                    id="myModalLabel" toggle={() => {
                        tog_standard();
                    }}>

                    Import Share Point
                </ModalHeader>
                <ModalBody>
                    <div className="share_point_input">
            <div>
              <Label htmlFor="site_url" className="form-label">Site URL</Label>
              <Input
                value={share_point_creds.site_url}
                onChange={on_change_site_url}
                type="text"
                className="form-control"
                id="site_url"
              />
              {errors.site_url && <div className="text-danger">{errors.site_url}</div>}
            </div>
            <div>
              <Label htmlFor="site_name" className="form-label">Site Name</Label>
              <Input
                value={share_point_creds.site_name}
                onChange={on_change_site_name}
                type="text"
                className="form-control"
                id="site_name"
              />
              {errors.site_name && <div className="text-danger">{errors.site_name}</div>}
            </div>
            <div>
              <Label htmlFor="client_id" className="form-label">Client ID</Label>
              <Input
                value={share_point_creds.client_id}
                onChange={on_change_client_id}
                type="text"
                className="form-control"
                id="client_id"
              />
              {errors.client_id && <div className="text-danger">{errors.client_id}</div>}
            </div>
            <div>
              <Label htmlFor="client_secret" className="form-label">Client Secret</Label>
              <Input
                value={share_point_creds.client_secret}
                onChange={on_change_client_secret}
                type="text"
                className="form-control"
                id="client_secret"
              />
              {errors.client_secret && <div className="text-danger">{errors.client_secret}</div>}
            </div>
            <div>
              <Label htmlFor="tenant_id" className="form-label">Tenant ID</Label>
              <Input
                value={share_point_creds.tenant_id}
                onChange={on_change_tenant_id}
                type="text"
                className="form-control"
                id="tenant_id"
              />
              {errors.tenant_id && <div className="text-danger">{errors.tenant_id}</div>}
            </div>
          </div>
          <div className="add_link mt-3" style={{ textAlign: 'right' }}>
            
          </div>
                </ModalBody>
                <div className="modal-footer">
                    <Button
                        color="light"
                        onClick={() => {
                            tog_standard();
                        }}
                    >
                        Close
                    </Button>
                    <Button onClick={() => {
                            tog_standard();
                            handleFetchFiles();
                        }} disabled={!isFormValid}>Fetch Files</Button>
                   
                </div>
            </Modal>
    </>
  )
}

export default Import_Sharepoint